import { returnAndNotify } from "common/api/with-notifications";
import { ApiCall } from "common/types/api";
import { CancellablePromise } from "common/types/promises";
import { SchedulerFilter } from "common/types/scheduler-filters";

export const schedulerFiltersApi = (apiCall: ApiCall) => ({
  listForEntity: (entityName: string) =>
    apiCall<SchedulerFilter[]>("get", `api/ui/scheduler-filters/${entityName}`),
  create: (filter: SchedulerFilter): CancellablePromise<{ id: number }> =>
    apiCall("post", "api/ui/scheduler-filters", filter).then(
      returnAndNotify(_("The filter was successfully created")),
    ),
  update: (filter: SchedulerFilter) =>
    apiCall("put", `api/ui/scheduler-filters/${filter.id}`, filter).then(
      returnAndNotify(_("The filter was successfully updated")),
    ),
  remove: (id: number) =>
    apiCall("delete", `api/ui/scheduler-filters/${id}`).then(
      returnAndNotify(_("The filter was successfully deleted")),
    ),
});
